import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Team from './pages/Team';
import Wills from './pages/willsTrusts/Wills';
import Trusts from './pages/willsTrusts/Trusts';
import Probate from './pages/probate/Probate';
import Footer from './components/Footer';
import NavigationBar from './components/NavigationBar';
import Contact from './pages/Contact';
import WillsTrustsPNC from './pages/willsTrusts/WillsTrustsPNC';
import WillsTrustsPreliminary from './pages/willsTrusts/WillsTrustsPreliminary';
import ProbatePNC from './pages/probate/ProbatePNC';
import ProbatePreliminary from './pages/probate/ProbatePreliminary';
import FileRepo from './pages/fileRepo/FileRepo';
import Profile from './pages/Profile';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminPage from './pages/adminPage/AdminPage';
import ViewPNC from './pages/ViewPNC';
import UsersPage from './pages/UsersPage';
import PasswordReset from './pages/PasswordReset';

function App() {
	return (
		<AuthProvider>
			<BrowserRouter>
				<NavigationBar />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/team" element={<Team />} />
					<Route path="/wills" element={<Wills />} />
					<Route path="/trusts" element={<Trusts />} />
					<Route path="/probate" element={<Probate />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/wills-trusts-pnc" element={<WillsTrustsPNC />} />
					<Route path="/probate-pnc" element={<ProbatePNC />} />
					<Route
						path="/wills-trusts-preliminary/:code"
						element={<WillsTrustsPreliminary />}
					/>
					<Route
						path="/probate-preliminary/:code"
						element={<ProbatePreliminary />}
					/>
					<Route
						path="/password-reset/:email/:code"
						element={<PasswordReset />}
					/>
					<Route
						path="/file-repo"
						element={
							<ProtectedRoute>
								<FileRepo />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/profile"
						element={
							<ProtectedRoute>
								<Profile />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin"
						element={
							<ProtectedRoute userLevel="admin">
								<AdminPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/view-pnc"
						element={
							<ProtectedRoute userLevel="admin">
								<ViewPNC />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/users"
						element={
							<ProtectedRoute userLevel="admin">
								<UsersPage />
							</ProtectedRoute>
						}
					/>
				</Routes>

				<Footer />
			</BrowserRouter>
		</AuthProvider>
	);
}

export default App;
